import React from 'react';
import { useParams } from 'react-router-dom';
import InvoiceDetail from './InvoiceDetail';

const InvoiceDetailWrapper: React.FC = () => {
  const { organisationId, invoiceId } = useParams<{ organisationId: string; invoiceId: string }>();

  if (!organisationId || !invoiceId) {
    return <div>Organisation ID and Invoice ID are required</div>;
  }

  return <InvoiceDetail organisationId={organisationId} invoiceId={invoiceId} />;
};

export default InvoiceDetailWrapper;
